export const currencyMaskOptions = {
    prefix: "$",
    suffix: "",
    includeThousandsSeparator: true,
    thousandsSeparatorSymbol: ",",
    allowDecimal: true,
    decimalSymbol: ".",
    decimalLimit: 2, // how many digits allowed after the decimal
    integerLimit: 12, // limit length of integer numbers
    allowNegative: false,
    allowLeadingZeroes: false,
};
const maxValueMonth = [31, 31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
const formatOrder = [
    "yyyy",
    "yyy",
    "yy",
    "y",
    "mmmm",
    "mmm",
    "mm",
    "m",
    "dd",
    "d",
    "HH",
    "MM",
    "SS",
];
export const dateMask = [/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/];
export const monthMask = [/\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/];
export const yearMask = [/\d/, /\d/, /\d/, /\d/];
export const rangeDateMask = [
    /\d/,
    /\d/,
    "/",
    /\d/,
    /\d/,
    "/",
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    " ",
    "-",
    " ",
    /\d/,
    /\d/,
    "/",
    /\d/,
    /\d/,
    "/",
    /\d/,
    /\d/,
    /\d/,
    /\d/,
];
export const rangeMonthMask = [
    /\d/,
    /\d/,
    "/",
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    " ",
    "-",
    " ",
    /\d/,
    /\d/,
    "/",
    /\d/,
    /\d/,
    /\d/,
    /\d/,
];
export const rangeYearMask = [/\d/, /\d/, /\d/, /\d/, " ", "-", " ", /\d/, /\d/, /\d/, /\d/];
export const createAutoCorrectedRangePipe = (dateFormat = "mm dd yyyy", { minYear = 1, maxYear = 9999 } = {}) => {
    const dateFormatArray = dateFormat
        .split(/[^dmyHMS]+/)
        .sort((a, b) => formatOrder.indexOf(a) - formatOrder.indexOf(b));
    return function (conformedValue) {
        const indexesOfPipedChars = [];
        const maxValue = {
            d: 31,
            dd: 31,
            m: 12,
            mm: 12,
            mmm: 12,
            mmmm: 12,
            y: 99,
            yy: 99,
            yyy: maxYear,
            yyyy: maxYear,
            HH: 23,
            MM: 59,
            SS: 59,
        };
        const minValue = {
            d: 1,
            dd: 1,
            m: 1,
            mm: 1,
            mmm: 1,
            mmmm: 1,
            y: 0,
            yy: 0,
            yyy: 0,
            yyyy: minYear,
            HH: 0,
            MM: 0,
            SS: 0,
        };
        const conformedValues = conformedValue.split(" - ").map((value, index) => {
            const conformedValueArr = value.split("");
            dateFormatArray.forEach((format) => {
                const position = dateFormat.indexOf(format);
                const maxFirstDigit = parseInt(maxValue[format].toString().substr(0, 1), 10);
                if (parseInt(conformedValueArr[position + index * 13], 10) > maxFirstDigit) {
                    conformedValueArr[position + 1 + index * 13] = conformedValueArr[position + index * 13];
                    conformedValueArr[position + index * 13] = "0";
                    indexesOfPipedChars.push(position + index * 13);
                }
            });
            let month = 0;
            const isInvalid = dateFormatArray.some((format) => {
                const position = dateFormat.indexOf(format);
                const length = format.length;
                const textValue = conformedValue.substr(position + index * 13, length).replace(/\D/g, "");
                const value = parseInt(textValue, 10);
                if (format === "mm") {
                    month = value || 0;
                }
                const maxValueForFormat = format === "dd" ? maxValueMonth[month] : maxValue[format];
                if (format === "yyyy" && (minYear !== 1 || maxYear !== 9999)) {
                    const scopedMaxValue = parseInt(maxValue[format].toString().substring(0, textValue.length), 10);
                    const scopedMinValue = parseInt(minValue[format].toString().substring(0, textValue.length), 10);
                    return value < scopedMinValue || value > scopedMaxValue;
                }
                return (value > maxValueForFormat || (textValue.length === length && value < minValue[format]));
            });
            if (isInvalid) {
                return false;
            }
            return conformedValueArr;
        });
        if (typeof conformedValues[0] === "boolean")
            return conformedValues[0];
        if (typeof conformedValues[1] === "boolean")
            return conformedValues[1];
        const value = conformedValues[0] && conformedValues[1]
            ? [...conformedValues[0], " ", "-", " ", ...conformedValues[1]].join("")
            : "";
        return {
            value,
            indexesOfPipedChars,
        };
    };
};
